// src/pages/Login.js

import React, { useEffect, useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { Link, useNavigate } from 'react-router-dom'
import { 
  Container, 
  TextField, 
  Button, 
  Typography, 
  Box, 
  Alert, 
  Grid, 
  Paper, 
  Avatar, 
  Checkbox, 
  FormControlLabel, 
  CircularProgress 
} from '@mui/material'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'

// Çoklu dil desteği
import { useTranslation } from 'react-i18next'

export default function Login() {
  const { t } = useTranslation()  // i18n Hook

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const { login, logout, currentUser } = useAuth()
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      setError('')

      const userCredential = await login(email, password)

      // Email onaylı mı kontrol edelim
      if (!userCredential.user.emailVerified) {
        await logout()
        setError(t('loginPage.errorEmailVerification'))
        return
      }

      setLoading(true)
    } catch (err) {
      setError(t('loginPage.errorLogin'))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (currentUser) {
      // currentUser gelince login tamam demektir
      navigate('/todolist')
    }
  }, [currentUser, navigate])

  return (
    <Container component="main" maxWidth="xs">
      <Paper elevation={6} sx={{ padding: 4, mt: 8, borderRadius: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {t('loginPage.title')}
          </Typography>

          {error && (
            <Alert severity="error" sx={{ width: '100%', mt: 2 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  type="email"
                  label={t('loginPage.emailLabel')}
                  variant="outlined"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  type="password"
                  label={t('loginPage.passwordLabel')}
                  variant="outlined"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                />
              </Grid>

              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox value="remember" color="primary" />}
                  label={t('loginPage.rememberMe')}
                />
              </Grid>
            </Grid>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              disabled={loading}
              sx={{ mt: 3, mb: 2, py: 1.5 }}
            >
              {loading 
                ? <CircularProgress size={24} color="inherit" /> 
                : t('loginPage.loginButton')
              }
            </Button>

            <Grid container justifyContent="space-between">
              <Grid item>
                <Link to="/forgot-password" style={{ textDecoration: 'none' }}>
                  <Typography variant="body2" color="primary">
                    {t('loginPage.forgotPassword')}
                  </Typography>
                </Link>
              </Grid>
              <Grid item>
                <Link to="/register" style={{ textDecoration: 'none' }}>
                  <Typography variant="body2" color="primary">
                    {t('loginPage.registerPrompt')}
                  </Typography>
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Paper>
    </Container>
  )
}